import {BaseModel} from '@app/core/models/base.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {IQOSelectData} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-select-data';

export class RoundingRule extends BaseModel {
	public type: RoundingRuleType;
	public method: RoundingRuleMethod;
	public minutes_of_rounding: number = null;
	public selectData: IQOSelectData<RoundingRuleMethod>;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);

		return this;
	}
}

export enum RoundingRuleType {
	BEFORE_SCHEDULED_START = 'BEFORE_SCHEDULED_START',
	AFTER_SCHEDULED_START = 'AFTER_SCHEDULED_START',
	BEFORE_SCHEDULED_END = 'BEFORE_SCHEDULED_END',
	AFTER_SCHEDULED_END = 'AFTER_SCHEDULED_END',
}

export enum RoundingRuleMethod {
	ROUND_UP = 'ROUND_UP',
	ROUND_NEAREST = 'ROUND_NEAREST',
	ROUND_DOWN = 'ROUND_DOWN',
	NO_ROUND_PUNCHED = 'NO_ROUND_PUNCHED',
	NO_ROUND_SCHEDULED = 'NO_ROUND_SCHEDULED',
}

export interface IRoundingRulesOrdered {
	BEFORE_SCHEDULED_START?: RoundingRule;
	AFTER_SCHEDULED_START?: RoundingRule;
	BEFORE_SCHEDULED_END?: RoundingRule;
	AFTER_SCHEDULED_END?: RoundingRule;
}
